import { jsx } from "react/jsx-runtime";
import { inheritDataTestId } from "../../utils/dataTestId.js";
import { ControlBody } from "../common/ControlBody.js";
import { PinCodeInput } from "./PinCodeInput.js";
import { DATA_TEST_ID_INHERITED } from "../../constants/DATA_TEST_ID_INHERITED.js";
const PinCodeControl = ({
  sx,
  label,
  error,
  tip,
  slotBelowInput,
  optional,
  className,
  disabled,
  hideTipText,
  compact,
  ignoreLabelHeight,
  ignoreHintHeight = !1,
  onChange,
  name,
  value,
  ...props
}) => /* @__PURE__ */ jsx(
  ControlBody,
  {
    sx,
    label,
    error,
    errorViewType: "below",
    tip,
    slotBelowInput,
    optional,
    className,
    disabled,
    hideTipText,
    compact,
    size: "md",
    ignoreLabelHeight,
    ignoreHintHeight,
    "data-test-id": inheritDataTestId(props),
    children: /* @__PURE__ */ jsx(
      PinCodeInput,
      {
        "data-test-id": DATA_TEST_ID_INHERITED,
        length: 6,
        onChange,
        value,
        className,
        name,
        error: !!error,
        disabled
      }
    )
  }
);
export {
  PinCodeControl
};
//# sourceMappingURL=PinCodeControl.js.map
